<template>
  <Modal
    :value="showModal"
    :title="'添加人员'"
    :mask-closable="false"
    width="600"
    @on-cancel="ManagerQuxiao"
  >
    <div class="box table-box">
      <div class="right-text">姓名</div>
      <AutoComplete
        v-model="autoValue"
        @on-search="searchManger"
        @on-select="selectAuto"
        :placeholder="'请输入姓名'"
      >
        <Option
          v-for="(item, index) in userlist"
          :value="index"
          :key="index"
        >{{ item.realName }}({{ item.userName || "无昵称" }})</Option>
      </AutoComplete>
    </div>
    <div class="box table-box">
      <div class="right-text">头像</div>
      <div class="form-avatar">
        <!-- <img
          class="form-avatar_img"
          :src="imgArr && imgArr[0]&& imgArr[0].path || require('@/assets/images/default.png')"
          title="用户头像"
        />-->
        <img
          class="form-avatar_img"
          :src="headPicUrl || require('@/assets/images/default.png')"
          title="用户头像"
        />
        <div class="form-avatar_option">
          <!-- 编辑 -->
          <i class="iconfont icon-bianji1" @click="avatarClick()"></i>
          <input
            type="file"
            id="uploads"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="avatarChange()"
            hidden
          />
          <!-- imgAee imgNumber 非必须参数 只是不传会报错 -->
          <upload-img
            :imgArr="imgArr"
            :fixedNumber="[1, 1]"
            :isClick="isClick"
            :isClickE="isClickE"
            :imgNumber="1"
            @saveImg="avatarSave($event)"
          ></upload-img>
        </div>
      </div>
    </div>
    <div class="box table-box">
      <div class="right-text">职务</div>
      <Select :value="proTitleId" placeholder="请选择职务" label-in-value @on-change="onJobChange">
        <Option v-for="item in jobList" :key="item.value" :value="item.value">{{item.label}}</Option>
      </Select>
    </div>
    <div class="box table-box">
      <div class="right-text">工作职责</div>
      <Input
      v-model="workResponse"
      size="large"
      placeholder="请输入工作职责"
      type="textarea"
      :rows="6"
      :maxlength="1000"
    />
    </div>
    <div slot="footer">
      <Button type="text" @click="ManagerQuxiao">取消</Button>
      <Button type="primary" @click="addMember">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadImg from "../../../components/uploadImg";
export default {
  props: {
    showModal: {
      //控制是否显示搜索弹窗
      type: Boolean,
      default: false,
    },
    zoneId: "",
  },
  data() {
    return {
      autoValue: "",
      selectMember: "",
      userlist: [], //搜索弹窗中搜索结果
      proTitle: "", // 要添加人员的职位
      proTitleId: "", // 职位对应的id
      id: "",
      headPicUrl: "",
      workResponse: "",
      valueChange: false,
      page: 1,
      isClick: 0, // 上传图片的事件触发标志
      isClickE: null, // 上传图片事件的触发对象 event
      jobList: [],
      imgArr: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 获取职务列表
    getJobList() {
      let url = this.urlobj.ownCommitteeJobList;
      console.log(url);
      this.$get(url)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.jobList = res.rows.map((item) => ({
            value: item.id,
            label: item.dicName,
          }));
        })
        .catch((e) => {
          alert(e.message);
        });
    },
    // job 发生变化
    onJobChange(e) {
      if (!e) return;
      console.log(e);
      this.proTitle = e.label;
      this.proTitleId = e.value;
    },
    // 添加人员
    addMember() {
      var that = this;
      let url = this.urlobj.addOwnCommittee;
      console.log(this.selectMember);
      // if (!this.selectMember) {
      //   that.$Message.warning("请选择人员");
      //   return;
      // }
      if (!this.proTitleId) {
        that.$Message.warning("请选择职务");
        return;
      }
      let data = {
        proTitleId: this.proTitleId,
        // ownerUid: this.selectMember.uid,
        userName: this.autoValue,
        zoneId: this.zoneId,
        positionName: this.workResponse,
      };
      if(this.selectMember) {
        data.ownerUid = this.selectMember.uid;
      }
      if (this.id) {
        data.id = this.id;
      }
      console.log("data", data);
      console.log(that.userlist);
      this._showSpin();
      this.$post(url, data)
        .then((res) => {
          this.page = 1;
          this.valueChange = false;
          if (res.isSucceed) {
            // 拼接用户数据
            if (that.id) this.$Message.success("修改成功");
            else this.$Message.success("添加成功");
            let _t = {};
            this.$emit("addMember", _t);
            this._initProp();
          }
        })
        .catch((e) => console.log(e));
    },
    // 取消按钮
    modalCancel() {
      this._initProp();
    },
    _searchManger(value) {
      var that = this;
      var url = this.urlobj.ownCommiteeList;
      this.$post(url, {
        pageNum: 1,
        pageSize: 10,
        userName: value,
        zoneId: this.zoneId,
      }).then((res) => {
        that.page++;
        that.isData = false;
        var list = [];
        res.rows.map((item) => {
          list.push({
            realName: item.realName,
            headPicUrl: item.headPicUrl,
            userName: item.userName,
            unionId: item.unionId,
            id: item.id,
            uid: item.uid,
          });
        });
        that.userlist = list;
        this.imgArr = [];
      });
    },
    selectAuto(value) {
      var autoValue = this.userlist[value];
      this.$nextTick(() => {
        this.autoValue = autoValue.realName || autoValue.userName; // 更新地点
        this.headPicUrl = autoValue.headPicUrl;
        console.log(autoValue);
      });
      this.selectMember = autoValue;
    },
    // 初始化数据
    _initProp() {
      this.proTitleId = "";
      this.modelInput = "";
      this.headPicUrl = "";
      this.userlist = [];
      this.autoValue = "";
      this.$emit("modalCancel");
    },
    _showSpin() {
      this.showSpin = true;
    },
    _hideSpin() {
      this.showSpin = false;
    },
    ManagerQuxiao() {
      this.$emit("quxiao");
    },
    avatarClick() {
      let oInput = document.getElementById("uploads");
      oInput.click();
    },
    avatarChange(event) {
      console.log(event);
      this.isClick++;
      this.isClickE = event;
    },
    avatarSave(event) {
      console.log(event);
      item.value = event;
      item.src = event.path;
      // 清空当前组件对应input 的file值 以便对于同一个图片触发change事件
      this.$refs[item.name][0].value = "";
    },
  },
  components: {
    uploadImg,
  },
  mounted() {},
  created() {
    this.searchManger = this._.debounce(this._searchManger, 500);
    this.getJobList();
  },
};
</script>
<style lang="less" scoped>
.modelInput {
  margin-top: 10px;
}
.searchcard-wrapper {
  position: relative;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  overflow-y: scroll;
}
.search-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 150px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}

.img img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.search-name {
  margin-top: 10px;
  color: #4b4b4b;
  font-weight: 600;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.searchcard-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}

.table-box {
  align-items: center;
  margin-bottom: 30px;
}
.right-text {
  width: 70px;
  text-align: right;
  margin-right: 10px;
}

.form-avatar {
  position: relative;
  width: 0.8rem;
  height: 0.8rem;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  // &:hover .form-avatar_option {
  //   .flex(center, center);
  // }
}
.form-avatar_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.form-avatar_option {
  display: none;
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  .icon-bianji1 {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
}
</style>
